import type {
  ConsentEventType,
  ConsentSource,
  GdprStatus,
} from '@/types/candidates';

export const CONSENT_EVENT_LABEL: Record<ConsentEventType, string> = {
  REQUESTED: 'Requested',
  GRANTED: 'Granted',
  REVOKED: 'Revoked',
  EXPIRED: 'Expired',
};

export const CONSENT_SOURCE_LABEL: Record<ConsentSource, string> = {
  EMAIL_LINK: 'Email link',
  MANUAL: 'Manual',
  CAREER_SITE: 'Career site',
  // HW-1023: the nightly job that marks an ended consent EXPIRED.
  SYSTEM: 'System',
};

export const GDPR_STATUS_LABEL: Record<GdprStatus, string> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  EXPIRED: 'Expired',
  REVOKED: 'Revoked',
};

export function gdprStatusTone(status: GdprStatus): string {
  switch (status) {
    case 'APPROVED':
      return 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400';
    case 'REVOKED':
      return 'bg-destructive/15 text-destructive';
    case 'EXPIRED':
      return 'bg-destructive/15 text-destructive';
    case 'PENDING':
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export function consentEventTone(type: ConsentEventType): string {
  switch (type) {
    case 'GRANTED':
      return 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400';
    case 'REVOKED':
      return 'bg-destructive/15 text-destructive';
    case 'EXPIRED':
      return 'bg-destructive/15 text-destructive';
    case 'REQUESTED':
    default:
      return 'bg-muted text-muted-foreground';
  }
}
